import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#56AA82",
      light: "#E3F1E6",
      contrastText: "#fff",
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paperWidthSm: {
          maxWidth: "600px",
          minWidth: "600px",
        },
        paperWidthMd: {
          maxWidth: "1010px",
          minWidth: "1010px",
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          boxShadow: "0px 1px 2px 0px rgba(37, 40, 45, 0.1)",
          fontSize: "16px",
          lineHeight: "20px",

          "&::placeholder": {
            color: "#596375",
            opacity: 1,
          }
        },
        sizeSmall: {
          fontSize: "12px",
          lineHeight: "16px",
        },
        input: {
          padding: "10px 12px",
          height: "auto",
        },
        inputSizeSmall: {
          padding: "8px 12px",
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          minHeight: "none",
          padding: "9px 12px",
          fontSize: "16px",
          lineHeight: "20px",

          "& em": {
            color: "#596375",
          }
        },
      }
    }
  }
});